import useEmblaCarousel from 'embla-carousel-react';
import { getFdCarouselContent } from '@components/Products/FixedDeposits/utils/utils';
import { Image, Text } from '@ui/atoms';
import {
    NextButton,
    PrevButton,
} from '@components/Products/FixedDeposits/Carousel/CarouselButtons';
import useWindowDimensions from '@hooks/useWindowDimensions';

const FDCarousels = ({ fixedDepositBanks }) => {
    const { width } = useWindowDimensions();
    const [emblaRef, emblaApi] = useEmblaCarousel({
        loop: true,
        align: width < 1280 ? 'center' : 'start',
        draggable: true,
    });

    const carouselContent = getFdCarouselContent(fixedDepositBanks);

    const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
    const scrollNext = () => emblaApi && emblaApi.scrollNext();

    return (
        <div className="relative w-full xl:px-16">
            <div className="relative xl:w-[952px] xl:mx-auto">
                <div
                    className="pb-4 overflow-hidden pt-6 xl:pt-10"
                    ref={emblaRef}
                    aria-label="Fixed Deposit Carousel"
                >
                    <div className="flex items-center gap-4 xl:gap-6">
                        {carouselContent.map((card, index) => (
                            <div
                                key={card.id}
                                className={`flex ${index === 0 ? 'ml-4 xl:ml-6' : ''}`}
                            >
                                <div className="relative flex flex-col justify-center gap-11 p-4 border border-gray-100 shadow-md select-none rounded-xl bg-basicWhite w-[240px] xl:w-[220px] overflow-hidden">
                                    <div className="flex items-center gap-2 relative z-10">
                                        <Image
                                            src={`/products/fixed-deposit/${card.icon}.svg`}
                                            className="w-12 h-12 mt-1"
                                            alt={card.title}
                                        />
                                        <Text
                                            content={card.title}
                                            className="text-gray-700 h6-semibold line-clamp-2"
                                        />
                                    </div>
                                    <div className="flex flex-col gap-2 relative z-10">
                                        {card.details.map(
                                            ({ label, value }, index) => (
                                                <div
                                                    key={index}
                                                    className="flex flex-col"
                                                >
                                                    <Text
                                                        content={label}
                                                        className="p5-regular text-gray-500"
                                                    />
                                                    <Text
                                                        content={value}
                                                        className="text-primary-500 h3-semibold"
                                                        isInnerHtml
                                                    />
                                                </div>
                                            )
                                        )}
                                    </div>
                                    <div className={'absolute top-0 -bottom-1 xl:-bottom-5 left-0 right-0 z-0 w-[240px] xl:w-[220px]  overflow-hidden rounded-xl'}>
                                        <Image
                                            src={
                                                '/images/products/bank-card-bg.svg'
                                            }
                                            className="w-full h-full overflow-hidden rounded-xl"
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <PrevButton
                    className="hidden xl:inline-block"
                    onClick={scrollPrev}
                />
                <NextButton
                    className="hidden xl:inline-block"
                    onClick={scrollNext}
                />
            </div>
            <div className="flex items-center justify-center gap-3 mt-6 xl:hidden">
                <PrevButton
                    className="inline-block xl:hidden"
                    onClick={scrollPrev}
                    isMobile
                />
                <NextButton
                    className="inline-block xl:hidden"
                    onClick={scrollNext}
                    isMobile
                />
            </div>
        </div>
    );
};

export default FDCarousels;
